module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.16253/images/shopify_disabled.png"